import { create } from 'zustand';

const useGlobalStore = create((set, get) => ({
  showKPI: localStorage.getItem('showKPI') === 'false' ? false : true,
  prevSelectedRow: { id: '', pathname: '' },

  // Action 
  setShowKPI: (showKPI) => {
    localStorage.setItem('showKPI', showKPI);
    set({ showKPI });
  },
  setPrevSelectedRow: (id, pathname) => set({ prevSelectedRow: { id, pathname } }),

  // Action to clear all stored data
  clearStore: () => set({
    showKPI: true,
    prevSelectedRow: { id: '', pathname: '' }
  }),

}));

export default useGlobalStore;
